import parsePhoneNumber, { CountryCode } from 'libphonenumber-js/mobile';
import * as fp from 'lodash/fp';

export default function phoneNumberValidation(
  phoneNumber: string,
  countryCode: CountryCode = 'TW',
): {
  formattedPhoneNumber: string;
  error: string;
} {
  if (fp.isEmpty(phoneNumber)) {
    return {
      formattedPhoneNumber: '',
      error: '請輸入手機號碼',
    };
  }

  const parsedPhoneNumber = parsePhoneNumber(phoneNumber, countryCode);

  if (!parsedPhoneNumber) {
    return {
      formattedPhoneNumber: '',
      error: '此電話號碼驗證失敗',
    };
  }

  if (!parsedPhoneNumber.isValid() || !parsedPhoneNumber.isPossible()) {
    return {
      formattedPhoneNumber: '',
      error: '此電話號碼不合法',
    };
  }

  if (parsedPhoneNumber.getType() !== 'MOBILE') {
    return {
      formattedPhoneNumber: '',
      error: '此號碼不是手機號碼',
    };
  }

  return {
    formattedPhoneNumber: parsedPhoneNumber.number as string,
    error: '',
  };
}
